"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removePageClick = exports.addPageClick = void 0;
var callbacks = [];

var registerMouseOver = function registerMouseOver(cbData) {
  cbData.$element.mouseover(function () {
    cbData.active = false;
  });
  cbData.$element.mouseout(function () {
    cbData.active = true;
  });
};

var onHTMLClick = function onHTMLClick(event) {
  callbacks.forEach(function (cbData) {
    if (cbData.active) {
      cbData.callback.apply(null, [event]);
    }
  });
};

var registerCallback = function registerCallback(callback, $elementNotAffected) {
  setTimeout(function () {
    // push to end of execution, since we don't want it to evaluate immediately if registered on a click event
    var callbackData = {
      callback: callback,
      $element: $elementNotAffected,
      active: true
    };
    callbacks.push(callbackData);

    if (callbacks.length === 1) {
      document.querySelector('html').addEventListener('click', onHTMLClick);
    }

    registerMouseOver(callbackData);
  }, 0);
};

exports.addPageClick = registerCallback;

var deregisterCallback = function deregisterCallback(callback) {
  var spliceIndex = -1;
  callbacks.forEach(function (cbData, index) {
    if (cbData.callback === callback) {
      spliceIndex = index;
    }
  });

  if (spliceIndex > -1) {
    callbacks.splice(spliceIndex, 1);
  }

  if (callbacks.length === 0) {
    document.querySelector('html').removeEventListener('click', onHTMLClick);
  }
};

exports.removePageClick = deregisterCallback;